import { Img } from "components";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PATHS } from "utils";

interface Props {
    disableNavigation?: string
}


const Stepper = ({ disableNavigation }: Props) => {

    const location = useLocation();
    const navigate = useNavigate();

    const currentIndex = PATHS?.slice(2)?.indexOf(location.pathname);

    const uniqueSteps = PATHS?.slice(2)?.reduce((acc: string[], path) => {
        const prefix = path.split('/')[2] || '/explore';  // get the first part after /
        const normalized = prefix === '' ? '/explore' : `/explore/${prefix}`; // make it a valid route like '/communication'

        if (!acc.includes(normalized)) {
            acc.push(normalized);  // only keep unique ones
        }
        return acc;
    }, []);

const visibleSteps = uniqueSteps.slice(0, -1);
    const currentPrefix = location.pathname.split('/')[2] || '/explore';
    const normalizedCurrentPrefix = currentPrefix === '' ? '/explore' : `/explore/${currentPrefix}`;
    const currentStepIndex = visibleSteps.indexOf(normalizedCurrentPrefix);

    const getPrefixGroup = (path: string) => {
        const parts = path.split('/');
        return parts.length > 2 ? `/explore/${parts[2]}` : (parts[2] ? `/explore/${parts[2]}` : '/explore');
    };

    const handleBack = () => {
        navigate(-1);
    }

    const handleSkip = () => {
        const currentPath = location.pathname;
        const currentGroup = getPrefixGroup(currentPath);
    
        const nextIndex = PATHS?.slice(2)?.findIndex((path, index) => {
            return index > currentIndex && getPrefixGroup(path) !== currentGroup;
        });
    
        if (nextIndex !== -1) {
            navigate(PATHS?.slice(2)[nextIndex]);
        }
    };

    const handleNext = () => {
        if (currentIndex < PATHS?.slice(2)?.length - 1) {
            navigate(PATHS?.slice(2)[currentIndex + 1]);
        }
    };

    return (<div className="grid grid-cols-5 gap-3 text-[2.8vh]">
        <div className={`col-span-5 flex ${/* currentIndex === 0 ? "justify-end" :  */"justify-between"} items-center`}>
            {/* currentIndex !== 0 &&  */<button disabled={!!disableNavigation} title={disableNavigation} onClick={handleBack} type="button" className={`flex gap-2 items-center font-manropeB py-[1.4vh] px-[1.8vh] text-smd_blue-dark ${!!disableNavigation ? "bg-[lightgray]" : "bg-[white]"} shadow-2xl shadow-[gray] border border-[gray] rounded-xl`}>
                <Img src="images/soomuch-demo/left-arrow-blue.svg" className="text-smd_blue-normal h-[3.5vh]" /> Back
            </button>}
            <div className="flex items-center gap-6">
                <button disabled={!!disableNavigation} title={disableNavigation} onClick={handleSkip} type="button" className={`flex gap-2 items-center font-manropeB py-[1.4vh] px-[1.8vh] ${!!disableNavigation ? "text-[black]" : "text-smd_blue-dark"} rounded-xl`}>
                    Skip
                </button>
                <button disabled={!!disableNavigation} title={disableNavigation} onClick={handleNext} type="button" className={`flex gap-2 items-center font-manropeB py-[1.4vh] px-[1.8vh] text-smd_blue-dark ${!!disableNavigation ? "bg-[lightgray]" : "bg-[white]"} shadow-2xl shadow-[gray] border border-[gray] rounded-xl`}>
                    Next <Img src="images/soomuch-demo/right-arrow-blue.svg" className="text-smd_blue-normal h-[3.5vh]" />
                </button>
            </div>
        </div>
        {visibleSteps.map((step, index) => (
            <div
                key={index}
                className={`w-full h-[2vh] rounded-lg border border-smd_blue-light ${index < currentStepIndex ? 'bg-smd_blue-light' : 'bg-smd_white-normal'
                    }`}
            ></div>
        ))}
    </div>);
}

export default Stepper;